import { z } from 'zod';
import { BaseAddressDTOSchema, } from "./addresses.dto.js";
import { ESupportedISOCountryIDs, } from "../../../../common/validators/value-objects.js";
// Country-specific postcode validation
const CountryPostcodeSchemas = Object.freeze({
    [ESupportedISOCountryIDs.BRAZIL]: z
        .string()
        .length(8)
        .regex(/^[0-9]+$/),
});
const hasSpecificPostcode = (countryId) => {
    return Object.prototype.hasOwnProperty.call(CountryPostcodeSchemas, countryId);
};
const validatePostcode = (data, ctx) => {
    if (!data.postcode || !hasSpecificPostcode(data.countryId))
        return;
    const postcodeSchema = CountryPostcodeSchemas[data.countryId];
    if (!postcodeSchema)
        return;
    const validationResult = postcodeSchema.safeParse(data.postcode);
    for (const issue of validationResult.error?.issues ?? []) {
        ctx.addIssue({ ...issue, path: [...issue.path, 'postcode'] });
    }
};
// Service layer DTOs
const BaseCreateAddressInputDTOSchema = BaseAddressDTOSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
});
export const CreateAddressInputDTOSchema = BaseCreateAddressInputDTOSchema.superRefine(validatePostcode);
// API layer DTOs - for standalone address creation (if needed)
export const CreateAddressRequestDTOSchema = z.object({
    body: CreateAddressInputDTOSchema,
});
//# sourceMappingURL=create-address.dto.js.map